module.exports = __webpack_public_path__ + "3e8caadc28415d8adc4fe509c323a65e.jpg";